import React from "react";
import {
  stylesGenericInputErrorCP,
  stylesGenericInputErrorTelcel,
} from "../../../styles/genericInputError";

class GenericInputError extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      titleStyles: {},
    };
  }

  componentDidMount() {
    const { isContainerTelcel } = this.props;
    this.setState({
      titleStyles: isContainerTelcel
        ? stylesGenericInputErrorTelcel
        : stylesGenericInputErrorCP,
    });
  }

  render() {
    const {
      titleStyles: { wrapper, paragraph },
    } = this.state;
    const { error } = this.props;
    return (
      <div style={wrapper}>
        <p style={paragraph}>{error}</p>
      </div>
    );
  }
}
export default GenericInputError;
